import api from './client'

export const dashboardApi = {
  getSummary: () => api.get('/api/dashboard/summary'),
}